<div *ngIf="isloader" class="h-100 w-100 padt-5">
  <mat-progress-bar [mode]="'indeterminate'">
  </mat-progress-bar>
</div>
<div class="d-flex flex-column" *ngIf="!isloader && !isError">
  <div class="vehicle-profile-header">
    {{widgetData?.title}}
    <span>
      &nbsp;
      <img 
        alt="Info"
        matTooltip="{{ MESSAGES?.ASSETCONDITION_TOOLTIP 
          | replace:'[UPPER_LIMIT]': gaugeSteps?.thresholdUpperLimit 
          | replace:'[LOWER_LIMIT]': gaugeSteps?.thresholdLowerLimit 
        }}"
        class="h-20px"
        src="../../../../assets/images/info-icon.svg">
    </span>
  </div>
  <div class="d-flex flex-column">
    <div>
      <div class="sub-header">Current Temperature Status for asset</div>
      <div class="flex1 p-4 d-flex justify-content-center pt-unset">
        <div class="vehicle-values w-100 vehicle-score-value p-20" [ngClass]="{'border-nodata': !guageData[0]?.color}"
          [style.color]="guageData[0]?.color">
          <span *ngIf="guageData[0]?.status">{{guageData[0]?.status
            | titlecase}}</span>
          <span *ngIf="!guageData[0]?.status">NA</span>
        </div>
      </div>
    </div>
    <div>
      <app-gauge-chart [gaugeData]="guageData"></app-gauge-chart>
    </div>
    <div *ngIf="sharedService?.rbacManagement('entities_EditThreshold')">
      <app-threshold-edit [loading]="onAssetConditionLoading" [threshold]="thresholdContent" (valueChanged)="onThresholdValueChange()"></app-threshold-edit>
    </div>
  </div>
</div>
<p *ngIf="isloader || isError">No Data Available</p>